import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "../charts/DashBoardResultSetUtil";
import {calcChartTitle} from "./HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighCombinationChart(userDashboardChartLine, h, w, widget, Highcharts) {
    let title = calcChartTitle(userDashboardChartLine);
    let list = userDashboardChartLine.resultSet;
    let params = userDashboardChartLine.parameters;
    let categs = [];
    let avgValues = [];
    let piePoints = [];
    let labelWithValues = new Map();
    let categParam = params[DashboardConstants.Param_ColumnCategory] || "";
    let labelParam = params[DashboardConstants.Param_ColumnLabel] || "";
    let valueParam = params[DashboardConstants.Param_ColumnValue] || "";
    let pieLabelParam = params[DashboardConstants.Param_PieLabel] || "";
    let pieValueParam = params[DashboardConstants.Param_PieValue] || "";
    let avgParam = params[DashboardConstants.Param_AvgValue] || "";
    let series = [];
    for (let i = 0; i < resultSetSize(list); i++) {
        let categ = getByColName(i, categParam, list);
        if (!categs.contains(categ))
            categs.push(categ);
        let label = getByColName(i, labelParam, list);
        if (!labelWithValues.get(label))
            labelWithValues.set(label, []);
        let value = getByColName(i, valueParam, list);
        labelWithValues.get(label).push(parseFloat(value));
        let avgValue = getByColName(i, avgParam, list);
        avgValues.push(parseFloat(avgValue));
        let x = getByColName(i, pieLabelParam, list);
        let pintValue = parseFloat(getByColName(i, pieValueParam, list));
        let point = {
            name: x, y: pintValue
        };
        piePoints[i] = point;
    }
    for (let [label, values] of labelWithValues.entries()) {
        series.push({name: label, type: "column", data: values});
    }
    series.push({name: "Average", type: "spline", data: avgValues});
    series.push({
        type: "pie", data: piePoints, center: [100, 10],
        size: 100,
        showInLegend: false,
        dataLabels: {
            enabled: false,
            useHTML: true
        },
        tooltip: {
            pointFormat: '{point.y}',
            useHTML: true
        },
    });
    let widgetId = widget.attr('id');
    Highcharts.chart(widgetId, {
        xAxis: {
            categories: categs
        },

        series: series
    });
}